import Model from './utils/model'
import nexus from '@db2b/nexus-js'
import moment from 'moment'

export default {
  ...Model,
  options: {
    translations: {
      name: 'Rappel'
    },
    name: 'reminder',
    url: nexus.url('callcenter', 'reminders')
  },
  toEvent (reminder) {
    return {
      date: {
        from: moment(reminder.date.date),
        to: moment(reminder.date.date).add(reminder.meeting_duration, 'minutes')
      },
      color: reminder.category.color,
      title: reminder.category.name,
      description: reminder.description,
      meta: {
        reminder
      }
    }
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/model/reminder.js